import React from 'react';

export const GIUDIZI = {
  pronto: { testo: "Pronto per l'ispezione", colore: '#059669', sfondo: 'bg-emerald-50 border-emerald-200 text-emerald-800' },
  quasi: { testo: 'Quasi pronto: sistema i punti gravi', colore: '#d97706', sfondo: 'bg-amber-50 border-amber-200 text-amber-800' },
  rischio: { testo: 'A rischio in caso di controllo', colore: '#dc2626', sfondo: 'bg-red-50 border-red-200 text-red-800' },
};

// Voto 0-100 in un anello che si riempie
export const VotoAnello = ({ voto, giudizio }) => {
  const r = 52;
  const giro = 2 * Math.PI * r;
  const colore = GIUDIZI[giudizio]?.colore || '#64748b';
  return (
    <div className="relative w-36 h-36 shrink-0" data-testid="ispezione-voto">
      <svg viewBox="0 0 120 120" className="w-full h-full -rotate-90">
        <circle cx="60" cy="60" r={r} fill="none" stroke="currentColor" strokeWidth="10" className="text-gray-200" />
        <circle cx="60" cy="60" r={r} fill="none" stroke={colore} strokeWidth="10" strokeLinecap="round"
          strokeDasharray={giro} strokeDashoffset={giro * (1 - voto / 100)}
          style={{ transition: 'stroke-dashoffset 1.2s cubic-bezier(.2,.8,.2,1)' }} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-4xl font-black text-gray-900" data-testid="ispezione-voto-numero">{voto}</span>
        <span className="text-xs text-gray-500">su 100</span>
      </div>
    </div>
  );
};
